<template>
	<div>
		<slot>Set content as inline template.</slot>
	</div>
</template>

<script>
	export default {
		data: function() {
			return {
				currentIndex: 0
			}
		},
		mounted: function () {
			let index = 1;
			while (this.$refs['item' + index]) {
				this.$refs['item' + index].style.height = 0;
				index++;
			}
		},
		methods: {
			showItem: function(index) {
				if (this.currentIndex) {
					this.$refs['item' + this.currentIndex].style.height = '0px';
				}
				if (index != this.currentIndex) {
					let height = 0;
					this.$refs['item' + index].childNodes.forEach((node) => {
						height += node.clientHeight;
					});
					this.$refs['item' + index].style.height = height + 'px';
				}
				this.currentIndex = this.currentIndex == index ? 0 : index;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Accordion.vue